module.exports = __webpack_public_path__ + "img/black-and-white.365fa69d.png";